/* ── Echo Valley — hero engine cycler ─────────────────────────────
   Cross-fades one tilted frame through every engine. Three kinds of slide:

     image — costs one opacity transition
     clip  — a video, fetched and played only while it is the slide on screen
     live  — a canvas panel, given display:none when it is not showing, which
             makes its driver stop the loop

   So whatever is in frame is the only thing doing any work.

   Slides are matched by data-i, not document order, because the floor
   reflection is a second full copy of the frame that has to stay in step.

   NB: tabs are .ev-etab, not .ev-tab — ev.js binds every .ev-tab on the page to
   the engine viewer and would blank its panels when a hero tab was clicked. */
(function () {
  var root = document.querySelector('.ev-cyc');
  if (!root) return;
  var slides = [].slice.call(root.querySelectorAll('.ev-slide'));
  var tabs = [].slice.call(root.querySelectorAll('.ev-etab'));
  var lives = [].slice.call(root.querySelectorAll('.ev-slide--live'));
  var vids = [].slice.call(root.querySelectorAll('.ev-slide--vid'));
  var count = tabs.length;
  if (count < 2 || !slides.length) return;

  var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  var HOLD = 5000, FADE = 800;
  var i = 0, timer = 0, manual = false, hovering = false, onscreen = false;

  /* Each live slide is judged on its own index: there can be more than one in
     the rotation, so a single shared flag would show or hide them together. */
  function liveVisibility() {
    lives.forEach(function (el) {
      var on = +el.getAttribute('data-i') === i;
      clearTimeout(el._evHide);
      if (on) el.style.display = '';
      else if (el.style.display !== 'none') {
        el._evHide = setTimeout(function () {
          if (+el.getAttribute('data-i') !== i) el.style.display = 'none';
        }, FADE);
      }
    });
  }
  /* Clips are preload=none in the markup, so nothing is fetched until an
     engine's turn comes round. Reduced motion leaves them on their poster. */
  function videoPlayback() {
    vids.forEach(function (el) {
      var v = el.querySelector('video');
      if (!v) return;
      if (+el.getAttribute('data-i') === i && !still && onscreen && !document.hidden) {
        if (v.preload === 'none') v.preload = 'auto';
        var pr = v.play();
        if (pr && pr.catch) pr.catch(function () {});
      } else { v.pause(); }
    });
  }
  function show(n, byHand) {
    i = (n + count) % count;
    slides.forEach(function (s) { s.classList.toggle('is-on', +s.getAttribute('data-i') === i); });
    tabs.forEach(function (b, k) {
      var on = k === i;
      /* re-adding the class restarts the CSS progress fill */
      if (on && b.classList.contains('is-on')) { b.classList.remove('is-on'); void b.offsetWidth; }
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
      b.tabIndex = on ? 0 : -1;
    });
    liveVisibility(); videoPlayback();
    if (byHand) { manual = true; root.classList.add('is-manual'); stop(); }
  }
  function stop() { clearTimeout(timer); timer = 0; }
  function arm() {
    stop();
    videoPlayback();
    if (manual || hovering || !onscreen || document.hidden) return;
    timer = setTimeout(function () { show(i + 1); arm(); }, HOLD);
  }
  function pause(p) {
    hovering = p;
    root.classList.toggle('is-paused', p);
    p ? stop() : arm();
  }

  tabs.forEach(function (b, k) {
    b.addEventListener('click', function () { show(k, true); });
    b.addEventListener('keydown', function (e) {
      var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
      if (!d) return;
      e.preventDefault();
      show(k + d, true);
      tabs[i].focus();
    });
  });
  root.addEventListener('pointerenter', function () { pause(true); });
  root.addEventListener('pointerleave', function () { pause(false); });
  root.addEventListener('focusin', function () { pause(true); });
  root.addEventListener('focusout', function () { pause(false); });
  document.addEventListener('visibilitychange', arm);

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es) { onscreen = es[0].isIntersecting; arm(); },
      { rootMargin: '80px' }).observe(root);
  } else { onscreen = true; }

  if (still) { manual = true; root.classList.add('is-manual'); }
  show(0);
  arm();
})();
